import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Form from "./Form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createInventoryInfovalidation } from "../../validation/InventoryInfo";
import { useEffect, useState } from "react";
import PopupModal from "../Reusable/Modal";
import CreateUnit from "./CreateUnit";
import ProductGroupForm from "./ProductGroup";

const EditProduct = (props: any) => {
  const { handleEdit, isLoading, data } = props;
  const [openUnitFormPopup, setOpenUnitFormPopup] = useState(false);
  const [openCategoryFormPopup, setOpenCategoryFormPopup] = useState(false);
  const {
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    register,
    setError,
    watch,
    control,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(createInventoryInfovalidation),
    defaultValues: async () => {
      return {
        category: data?.category,
        unit: {
          id: data?.unit?.id,
          short_code: data?.unit?.name,
        },
        hs_code: data?.hs_code,
        description: data?.description,
        name: data?.name,
        opening_quantity: data?.opening_quantity,
        opening_rate: data?.opening_rate,
        opening_balance: data?.opening_balance,
        is_taxable: data?.is_taxable,
      };
    },
  });
  const openingQuantity = watch("opening_quantity");
  const openingRate = watch("opening_rate");

  useEffect(() => {
    const quantity = parseFloat(openingQuantity);
    const rate = parseFloat(openingRate);
    if (!isNaN(quantity) && !isNaN(rate)) {
      const openingValue = quantity * rate;
      setValue("opening_balance", openingValue);
    } else {
      setValue("opening_balance", "");
    }
  }, [openingQuantity, openingRate]);
  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleEdit(data, setError))}
          className={tw`px-4`}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            watch={watch}
            getValues={getValues}
            setOpenCategoryFormPopup={setOpenCategoryFormPopup}
            setOpenUnitFormPopup={setOpenUnitFormPopup}
            clearErrors={clearErrors}
          />
          <div className={tw`flex w-full justify-end`}>
            <div className={tw`w-24 flex gap-x-4 items-center`}>
              <Button label="Save" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        title="Create Unit"
        isOpen={openUnitFormPopup}
        setIsOpen={setOpenUnitFormPopup}
      >
        <CreateUnit setOpenUnitFormPopup={setOpenUnitFormPopup} />
      </PopupModal>
      <PopupModal
        title="Create Category"
        isOpen={openCategoryFormPopup}
        setIsOpen={setOpenCategoryFormPopup}
      >
        <div className={tw`min-w-[400px]`}>
          <ProductGroupForm
            setOpenCategoryFormPopup={setOpenCategoryFormPopup}
          />
        </div>
      </PopupModal>
    </>
  );
};

export default EditProduct;
